
import HomePage from '../pages/home.vue';
import AboutPage from '../pages/about.vue';
import FormPage from '../pages/form.vue';
import CatalogPage from '../pages/catalog.vue';
//import ProductPage from '../pages/product.vue';
import SettingsPage from '../pages/settings.vue';

import GalleryPage from '../pages/auth/gallery.vue';
import ViewUserProfilePage from '../pages/auth/viewuserprofile.vue';
import DynamicRoutePage from '../pages/dynamic-route.vue';
import RequestAndLoad from '../pages/request-and-load.vue';
import NotFoundPage from '../pages/404.vue';
import SignInPageBackup from '../pages/auth/signinbackup.vue';
import SignInPage from '../pages/auth/signin.vue';
import FirstPagePage from '../pages/auth/firstpage.vue';
import SignUpPage from '../pages/auth/signup.vue';
import EditProfilePage from '../pages/auth/editprofile.vue';
import AddPhotoPage from '../pages/auth/addphoto.vue';
import ViewProfilePage from '../pages/auth/viewprofile.vue';
import EditProfilePicturePage from '../pages/auth/editprofilepicture.vue';
import PhoneVerifyPage from '../pages/auth/phoneverify.vue';
import NewVersion from '../pages/auth/newversion.vue';
import VerifyEmail from '../pages/auth/verifyemail.vue';


import ContactsPage from '../pages/chat/contacts.vue';
import Pay4mePage from '../pages/chat/pay4me.vue';
import MembersPage from '../pages/chat/members.vue';
import MatchPage from '../pages/chat/match.vue';
import LiveScoresPage from '../pages/chat/livescores.vue';
import StandingsPage from '../pages/chat/standings.vue';
import RequestsPage from '../pages/chat/requests.vue';
import ChatPage from '../pages/chat/chat.vue';
import UserNotificationsPage from '../pages/chat/usernotifications.vue';
import AffiliatePage from '../pages/chat/affiliate.vue';
import BeamoderatorPage from '../pages/chat/beamoderator.vue';
import SportsUpdatePage from '../pages/chat/sportsupdate.vue';

import ChatGroups from '../pages/chatgroups/chatgroups.vue';
import ChatGroup from '../pages/chatgroups/chatgroup.vue';
import PostFriends from '../pages/chatgroups/postfriends.vue';
import NewGroup from '../pages/chatgroups/newgroup.vue';
import AddMembers from '../pages/chatgroups/addmembers.vue';
import GroupInfo from '../pages/chatgroups/groupinfo.vue';
import GroupMembers from '../pages/chatgroups/groupmembers.vue';



var routes = [

  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/signin/',
    component: SignInPage,
  },

  {
    path: '/signinbackup/',
    component: SignInPageBackup,
  },

  {
    path: '/firstpage/',
    component: FirstPagePage,
  },
  {
    path: '/signup/:phone',
    component: SignUpPage,
  },
  {
    path: '/viewprofile/',
    component: ViewProfilePage,
  },
  {
    path: '/editprofile/',
    component: EditProfilePage,
  },

  {
    path: '/addphoto/',
    component: AddPhotoPage,
  },
  {
    path: '/editprofilepicture/',
    component: EditProfilePicturePage,
  },
  {
    path: '/phoneverify/',
    component: PhoneVerifyPage,
  },
  {
    path: '/verifyemail/:email',
    component: VerifyEmail,
  },
  {
    path: '/members/',
    component: MembersPage,

  },
  {
    path: '/match/',
    component: MatchPage,
  },
  {
    path: '/newversion/',
    component: NewVersion,
  },

  {

    path: '/about/',
    name: "AboutPage",
    component: AboutPage,
  },

  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/catalog/',
    component: CatalogPage,
  },
  {
    path: '/pay4me/:frd',
    component: Pay4mePage,
  },
  {
    path: '/settings/',
    component: SettingsPage,
  },
  {
    path: '/contacts/',
    component: ContactsPage,
  },
  {
    path: '/requests/',
    component: RequestsPage,
  },
  {
    path: '/chat/:frd',
    component: ChatPage,
  },
  {
    path: '/gallery/:frd',
    component: GalleryPage,
  },

  {
    path: '/viewuserprofile/:frd',
    component: ViewUserProfilePage,
  },

  {
    path: '/usernotifications/',
    component: UserNotificationsPage,
  },
  {
    path: '/livescores/',
    component: LiveScoresPage,
  },
  {
    path: '/sportsupdate/',
    component: SportsUpdatePage,
  },
  {
    path: '/standings/',
    component: StandingsPage,
  },
  {
    path: '/affiliate/',
    component: AffiliatePage,
  },
  {
    path: '/beamoderator/',
    component: BeamoderatorPage,
  },
  {
    path: '/chatgroups/',
    component: ChatGroups,
  },
  {
    //path: '/chatgroup/:group',
    path: '/chatgroup/',
    component: ChatGroup,
  },
  {
    //path: '/chatgroup/:group',
    path: '/postfriends/',
    component: PostFriends,
  },
  {
    path: '/newgroup/',
    component: NewGroup,
  },
  {
    path: '/addmembers/:group_name',
    component: AddMembers,
  },
  {
    path: '/groupmembers/:group_name',
    component: GroupMembers,
  },
  {
    path: '/groupinfo/:group_name',
    component: GroupInfo,
  },

  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
